/** Pedir o link de redefinição (SPEC-IDN-012).
 *
 * A confirmação é **sempre a mesma**, exista ou não a conta — e é deliberado
 * que a tela pareça um pouco vaga aqui. Dizer "não encontramos esse e-mail"
 * seria útil para quem digitou errado e igualmente útil para quem está varrendo
 * uma lista para descobrir quem é cliente.
 *
 * O texto compensa a vagueza sendo específico sobre o que fazer em seguida:
 * conferir a caixa de entrada e o spam, e tentar de novo se nada chegar.
 */

import { useState, type SyntheticEvent } from "react";

import { Botao } from "@/shared/ui/Botao";
import { Campo } from "@/shared/ui/Campo";

import { pedirRedefinicao } from "./api";

export function EsqueciMinhaSenha({ aoVoltar }: { aoVoltar: () => void }) {
  const [email, setEmail] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function enviar(evento: SyntheticEvent) {
    evento.preventDefault();
    if (email.trim() === "" || enviando) return;

    setEnviando(true);
    try {
      await pedirRedefinicao(email.trim());
    } catch {
      // Falha de rede também vira confirmação. Distinguir "não enviei" de
      // "não existe" devolveria pela porta dos fundos a informação que a
      // resposta genérica esconde.
    } finally {
      setEnviando(false);
      setEnviado(true);
    }
  }

  if (enviado) {
    return (
      <Moldura>
        <h1 className="font-display text-display-md text-texto">Confira seu e-mail</h1>
        <p className="font-texto text-body text-texto-suave">
          Se houver uma conta com <strong className="text-texto">{email.trim()}</strong>, enviamos
          um link para escolher uma nova senha. Ele vale por uma hora.
        </p>
        <p className="font-texto text-caption text-texto-tenue">
          Não chegou? Confira a caixa de spam e tente de novo em alguns minutos.
        </p>
        <Botao variante="secundario" larguraTotal onClick={aoVoltar}>
          Voltar para a entrada
        </Botao>
      </Moldura>
    );
  }

  return (
    <Moldura>
      <div className="flex flex-col gap-2">
        <h1 className="font-display text-display-md text-texto">Esqueceu a senha?</h1>
        <p className="font-texto text-body text-texto-suave">
          Informe o e-mail da sua conta e mandamos um link para escolher uma nova.
        </p>
      </div>

      <form
        onSubmit={(evento) => void enviar(evento)}
        aria-label="Recuperar senha"
        className="flex flex-col gap-4"
      >
        <Campo
          rotulo="E-mail"
          type="email"
          value={email}
          onChange={(evento) => {
            setEmail(evento.target.value);
          }}
          autoComplete="email"
          required
          autoFocus
        />

        <Botao type="submit" larguraTotal carregando={enviando} disabled={email.trim() === ""}>
          Enviar link
        </Botao>

        <Botao type="button" variante="fantasma" larguraTotal onClick={aoVoltar}>
          Voltar
        </Botao>
      </form>
    </Moldura>
  );
}

function Moldura({ children }: { children: React.ReactNode }) {
  return (
    <main className="grid min-h-dvh place-items-center bg-canvas px-6">
      <div className="flex w-full max-w-[420px] flex-col gap-6">{children}</div>
    </main>
  );
}
